// Three-step quote request on the quote page: services, building, contact details.
// Submitted to the same Formie form as the homepage hero; on success the visitor goes to its confirmation page.
window.quoteRequest = function (config) {
    return {
        step: 1,
        picked: [],
        situation: null,
        buildingType: '',
        buildYear: '',
        street: '',
        postcode: '',
        city: '',
        applicant: 'Particulier',
        files: [],
        error: false,
        sent: false,
        submitting: false,
        serverErrors: [],
        init() {
            // Service pages and the situation helper on the homepage link here with ?dienst=<option>, once per
            // service, to preselect them
            const preselect = new URLSearchParams(window.location.search)
                .getAll('dienst')
                .filter((value) => config.options.some((option) => option.value === value));
            if (preselect.length) {
                this.picked = preselect;
            }

            // Coming back from the confirmation page via the back/forward cache
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    this.submitting = false;
                }
            });
        },

        // -- Step 1: services --
        isPicked(value) {
            return this.picked.includes(value);
        },
        onPick(event) {
            // "Not sure yet" excludes every other service, and the other way around
            const { value, checked } = event.target;
            let next = this.picked.filter((picked) => picked !== value);

            if (checked) {
                next = value === config.unsureValue ? [value] : next.filter((picked) => picked !== config.unsureValue).concat(value);
            }

            this.picked = next;
            this.error = false;
        },
        pickSituation(id) {
            if (this.situation === id) {
                this.situation = null;
                return;
            }
            this.situation = id;
            this.picked = [...config.situations[id].services];
            this.error = false;
        },
        get situationHint() {
            return this.situation ? config.situations[this.situation].hint : '';
        },
        get pickedLabels() {
            return config.options
                .filter((option) => this.isPicked(option.value))
                .map((option) => option.summaryLabel || option.label);
        },
        get hasAsbestos() {
            return this.isPicked(config.asbestosValue);
        },
        get hasTank() {
            return this.isPicked(config.tankValue);
        },

        // -- Summary --
        get tip() {
            const services = this.picked.filter((picked) => picked !== config.unsureValue);
            if (this.isPicked(config.epcValue) && this.hasAsbestos) {
                return config.texts.tipCombined;
            }
            return services.length > 1 ? config.texts.tipOneQuote : '';
        },
        get buildingSummary() {
            const type = this.buildingType;
            const year = config.buildYears[this.buildYear] || '';
            if (type) {
                return year ? `${type}, ${year}` : type;
            }
            return year ? `${config.texts.building} ${year}` : '';
        },
        get addressSummary() {
            const place = [this.postcode, this.city].filter(Boolean).join(' ');
            return [this.street, place].filter(Boolean).join(', ');
        },
        get notePlaceholder() {
            return this.isPicked(config.unsureValue) ? config.texts.notePlaceholderUnsure : config.texts.notePlaceholder;
        },

        // -- Steps --
        next() {
            if (this.step === 1 && !this.picked.length) {
                this.error = true;
                return;
            }
            if (this.step === 2 && !this.validate(this.$refs.stepTwo)) {
                return;
            }
            this.goTo(this.step + 1);
        },
        back() {
            this.goTo(this.step - 1);
        },
        goTo(step) {
            this.step = step;
            this.error = false;
            this.$nextTick(() => {
                // Bring the top of the form back into view when it scrolled out
                const top = this.$refs.card.getBoundingClientRect().top;
                if (top < 0) {
                    window.scrollTo({ top: window.scrollY + top - 104, behavior: 'smooth' });
                }
                this.$refs[`heading${step}`]?.focus({ preventScroll: true });
            });
        },
        validate(container) {
            const invalid = [...container.querySelectorAll('input, select, textarea')].find((field) => !field.checkValidity());
            if (invalid) {
                invalid.reportValidity();
                return false;
            }
            return true;
        },

        // -- Files --
        onFiles() {
            this.files = [...this.$refs.files.files].map((file) => file.name);
        },
        onDrop(event) {
            this.$refs.files.files = event.dataTransfer.files;
            this.onFiles();
        },

        // -- Submit --
        async submit(event) {
            // Enter in a field of an earlier step moves on instead of sending
            if (this.step < 3) {
                this.next();
                return;
            }
            if (!this.validate(this.$refs.stepThree)) {
                return;
            }

            const form = event.target;
            this.submitting = true;
            this.serverErrors = [];
            let redirecting = false;

            try {
                const result = await window.submitFormie(form, config);

                if (result.success) {
                    const data = new FormData(form);
                    window.saveQuoteSummary({
                        services: this.pickedLabels.join(', '),
                        address: this.addressSummary,
                        email: data.get('fields[email]') || '',
                        phone: data.get('fields[phone][number]') || '',
                    });

                    if (result.redirectUrl) {
                        // Keep the button disabled while the confirmation page loads
                        redirecting = true;
                        window.location.assign(result.redirectUrl);
                        return;
                    }

                    this.sent = true;
                    this.$nextTick(() => this.$refs.confirmation.focus());
                    return;
                }

                this.serverErrors = result.errors.length ? result.errors : [config.messages.generic];
            } catch (error) {
                this.serverErrors = [config.messages.generic];
            } finally {
                this.submitting = redirecting;
            }
        },
    };
}
